

exports.__esModule = true;

require('jquery');

require('angularPlaceHolderShim');

require('js/lib/index');

require('xo-tracking/dist/index');

var _index = require('squid/index');

var _middleware = require('js/lib/middleware');

require('pages/xo-landing/route');

require('pages/xo-login/route');

require('pages/xo-generic-error/route');

require('pages/xo-generic-message/route');

require('pages/xo-select-fi/route');

require('pages/xo-review/route');

require('pages/xo-authorization-message/route');

require('pages/xo-add-card/route');

require('pages/xo-add-fi/route');

require('pages/xo-add-card-meft/route');

require('pages/xo-add-tax-id/route');

require('pages/xo-add-shipping/route');

require('pages/xo-add-national-id/route');

require('pages/xo-update-card/route');

require('pages/xo-eConsent/route');

require('pages/xo-travel-rule/route');

require('pages/xo-nbr/route');

require('pages/xo-framebust/route');

require('pages/xo-sepa/route');

require('pages/xo-pay');

require('pages/xo-end/route');

require('pages/xo-de-guest/route');

require('xo-login-components/src/fullpage-onetouch-upsell/route');

require('xo-login-components/src/onetouch-interstitial/route');

require('pages/xo-create-password/route');

require('pages/xo-tokenization-info/route');

require('pages/xo-pin-setup/route');

require('pages/xo-venmo/route');

require('pages/xo-third-party-wallet/route');

require('pages/xo-third-party-info/route');

require('pages/xo-inventory-soldout/route');

require('xo-page-components/src/done/route');

require('xo-form-components/src/phone/route');

require('xo-credit-components/src/bml-display/route');

require('xo-credit-components/src/choose-credit-offer/route');

require('xo-credit-components/src/redirect-to-cape/route');

require('pages/xo-pay-with-selection/route');

require('pages/xo-cip-verification/route');

require('pages/xo-venmoAuth/route');

require('./directive');

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
exports['default'] = _index.$Route.extend('$xoCheckoutRoute', {
    path: 'checkout',
    directive: 'xo-checkout',
    titleContent: 'base.payPal',
    defaultState: 'checkout.landing',
    middleware: _middleware.$Middleware,
    children: [{
        name: '$LandingRoute'
    }, {
        name: '$LoginRoute',
        attributes: {
            token: 'token'
        }
    }, {
        name: '$PayWithSelectionRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-pay-with-selection/route',
        slug: 'payWithSelection'
    }, {
        name: '$VenmoRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-venmo/route',
        slug: 'venmo'
    }, {
        name: '$VenmoAuthRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-venmoAuth/route',
        slug: 'venmoAuth'
    }, {
        name: '$ThirdPartyWalletFlowRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-third-party-wallet/route',
        slug: 'thirdPartyWalletFlow'
    }, {
        name: '$ThirdPartyInfoCollectFlowRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-third-party-info/route',
        slug: 'thirdPartyInfoCollectFlow'
    }, {
        name: '$GenericErrorRoute',
        lazyRoute: 'pages/xo-generic-error/route',
        slug: 'genericError'
    }, {
        name: '$ChooseCreditOfferRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'xo-credit-components/src/choose-credit-offer/route',
        slug: 'chooseCreditOffer'
    }, {
        name: '$RedirectToCapeRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'xo-credit-components/src/redirect-to-cape/route',
        slug: 'redirectToCape'
    }, {
        name: '$GenericMessageRoute',
        lazyRoute: 'pages/xo-generic-message/route',
        slug: 'genericMessage'
    }, {
        name: '$FullpageOnetouchUpsellRoute',
        lazyRoute: 'xo-login-components/src/fullpage-onetouch-upsell/route',
        slug: 'FullpageOnetouchUpsell'
    }, {
        name: '$OneTouchUpsellRoute',
        attributes: {
            'token': 'token'
        },
        lazyRoute: 'xo-login-components/src/onetouch-interstitial/route',
        slug: 'oneTouchUpsell'
    }, {
        name: '$SelectFiRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-select-fi/route',
        slug: 'selectFi'
    }, {
        name: '$ReviewRoute'
    }, {
        name: '$AuthorizationMessageRoute',
        lazyRoute: 'pages/xo-authorization-message/route',
        slug: 'authorizationmessage'
    }, {
        name: '$AddPhoneRoute',
        lazyRoute: 'xo-form-components/src/phone/route',
        slug: 'addPhone'
    }, {
        name: '$AddCardPageRoute',
        lazyRoute: 'pages/xo-add-card/route',
        slug: 'pageAddCard'
    }, {
        name: '$AddFiPageRoute',
        lazyRoute: 'pages/xo-add-fi/route',
        slug: 'pageAddFi'
    }, {
        name: '$xoTokenizationInfoPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-tokenization-info/route',
        slug: 'tokenizationInfo'
    }, {
        name: '$xoPinSetupPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-pin-setup/route',
        slug: 'pinSetup'
    }, {
        name: '$AddCardMeftRoute',
        lazyRoute: 'pages/xo-add-card-meft/route',
        slug: 'pageAddCardMeft'
    }, {
        name: '$AddTaxIdRoute',
        lazyRoute: 'pages/xo-add-tax-id/route',
        slug: 'addTaxId'
    }, {
        name: '$TravelRuleRoute',
        lazyRoute: 'pages/xo-travel-rule/route',
        slug: 'travelRule'
    }, {
        name: '$AddNationalIdRoute',
        lazyRoute: 'pages/xo-add-national-id/route',
        slug: 'addNationalId'
    }, {
        name: '$UpdateCardPageRoute',
        lazyRoute: 'pages/xo-update-card/route',
        slug: 'updateCard'
    }, {
        name: '$AddShippingPageRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-add-shipping/route',
        slug: 'pageAddShipping'
    }, {
        name: '$xoSoldOutPageRoute',
        lazyRoute: 'pages/xo-inventory-soldout/route',
        slug: 'soldout'
    }, {
        name: '$xoEConsentPageRoute',
        props: function props() {
            var _this = this;

            return {
                token: this.token,
                success: function success() {
                    return _this.goto('this.review');
                }
            };
        },

        lazyRoute: 'pages/xo-eConsent/route',
        slug: 'econsent'

    }, {
        name: '$xoNbrDEPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-nbr/route',
        slug: 'negativeBalanceRecovery'

    }, {
        name: '$xoFrameBustRoute',
        lazyRoute: 'pages/xo-framebust/route',
        slug: 'framebust'
    }, {
        name: '$SepaPageRoute',
        attributes: {
            token: 'token'
        },
        lazyRoute: 'pages/xo-sepa/route',
        slug: 'sepapage'
    }, {
        name: '$PayRoute',
        lazyRoute: 'pages/xo-pay/route',
        slug: 'pay'
    }, {
        name: '$EndRoute',
        slug: 'end'
    }, {
        name: '$xoDeGuest',
        lazyRoute: 'pages/xo-de-guest/route',
        slug: 'xoDeGuest'
    }, {
        name: '$BMLDisplay',
        attributes: {
            'review-url': 'reviewUrl'
        },
        lazyRoute: 'xo-credit-components/src/bml-display/route',
        slug: 'bmldisplay'
    }, {
        name: '$DoneRoute',
        lazyRoute: 'xo-page-components/src/done/route',
        slug: 'done'
    }, {
        name: '$xoPageCreatePasswordRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: 'pages/xo-create-password/route',
        slug: 'createPassword'
    }, {
        name: '$xoCIPVerficationPageRoute',
        props: function props() {
            return { token: this.token };
        },

        lazyRoute: 'pages/xo-cip-verification/route',
        slug: 'cipverification'

    }]
}); /* dynamic-import */

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */

_index.$Route;

_middleware.$Middleware;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-checkout/route.js
// module id = ./pages/xo-checkout/route.js
// module chunks = 0